import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ImportFileView from "@/views/ImportFileView";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/import_file',
    name: 'ImportFile',
    component: ImportFileView
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
